import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { downloadDocument } from "../../services/downloadService";
import "./FileList.scss";

import imgMontaz from "../../assets/montazni-navod.png";
import imgProjekt from "../../assets/projektova-smernice.png";
import imgKatalog from "../../assets/katalog-produktu.png";
import imgMontaz015 from "../../assets/montazni-navod015.png";

const files = [
  {
    id: 1,
    titleKey: "dashboard.files.installationManualHcc07",
    filename: "Montážní návod HCC-07 IP 2025 z.pdf",
    buttonColor: "bg-blue-600",
    image: imgMontaz,
  },
  {
    id: 2,
    titleKey: "dashboard.files.projectGuidelineHcc07",
    filename: "Projektová směrnice HCC-07 IP 2025 z.pdf",
    buttonColor: "bg-blue-600",
    image: imgProjekt,
  },
  {
    id: 3,
    titleKey: "dashboard.files.productCatalogHcc07",
    filename: "Katalog produktů HCC-07 IP 2025 z.pdf",
    buttonColor: "bg-blue-600",
    image: imgKatalog,
  },
  {
    id: 4,
    titleKey: "dashboard.files.installationManualHcc015",
    filename: "Montážní návod HCC-01.5 2025.pdf",
    buttonColor: "bg-blue-600",
    image: imgMontaz015,
  },
];

export default function FileList() {
  const { t } = useTranslation();

  // Track download progress and status for each file card
  const [downloadStates, setDownloadStates] = useState({});

  // Start document download and update progress state
  const handleDownload = async (fileId, filename) => {
    setDownloadStates((prev) => ({
      ...prev,
      [fileId]: { percent: 0, status: "downloading" },
    }));

    try {
      await downloadDocument(filename, (loaded, total) => {
        const percent = total ? Math.round((loaded / total) * 100) : 0;

        setDownloadStates((prev) => ({
          ...prev,
          [fileId]: { percent, status: "downloading" },
        }));
      });

      setDownloadStates((prev) => ({
        ...prev,
        [fileId]: { percent: 100, status: "done" },
      }));

      setTimeout(() => {
        setDownloadStates((prev) => ({
          ...prev,
          [fileId]: null,
        }));
      }, 2000);
    } catch (error) {
      alert(`${t(["common.error", "Error"])}: ${error.message}`);
      setDownloadStates((prev) => ({
        ...prev,
        [fileId]: null,
      }));
    }
  };

  return (
    <div className="file-list-wrapper">
      <div className="file-list-inner">
        <h2 className="file-list-heading">{t("dashboard.heading")}</h2>

        <div className="file-grid">
          {files.map((file) => {
            const state = downloadStates[file.id];
            const isDownloading = state?.status === "downloading";
            const isDone = state?.status === "done";
            const fileTitle = t(file.titleKey);

            return (
              <div className="file-card" key={file.id}>
                <div className="file-card-image">
                  <img src={file.image} alt={fileTitle} />
                </div>

                <div className="file-card-content">
                  <p className="file-card-title">{fileTitle}</p>

                  {isDone ? (
                    <div className="download-complete">
                      {t("dashboard.downloadDone")}
                    </div>
                  ) : (
                    <button
                      type="button"
                      className={`file-download-button ${file.buttonColor}`}
                      onClick={() => handleDownload(file.id, file.filename)}
                      disabled={isDownloading}
                    >
                      {isDownloading
                        ? t("dashboard.downloading")
                        : t("dashboard.downloadButton")}
                    </button>
                  )}

                  {isDownloading && (
                    <div className="progress-bar-wrapper">
                      <div
                        className="progress-bar-inner"
                        style={{ width: `${state.percent}%` }}
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
